import NamedDto from 'modules/base/dto/NamedDto';

export class VizsgaTableDto extends NamedDto {
	/**
	 * @module VizsgaTableDto
	 */
	constructor() {
		super();
		/** @type {string} */
		this.leiras = null;
		/** @type {Date} */
		this.datum = null;
	}

	/**
	 * @typedef {Object} _VizsgaTableDtoProps
	 * @property {string} leiras
	 * @property {Date} datum
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _VizsgaTableDtoProps} VizsgaTableDtoProps
	 */
	/**
	 *
	 * @param {VizsgaTableDtoProps} props
	 * @returns {VizsgaTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.leiras = props.leiras;
		this.datum = props.datum !== null ? new Date(props.datum) : null;
		return this;
	}
}

export default VizsgaTableDto;
